import { useEffect } from "react";
import Button from "../../components/Button";
import { TOKEN, WALLET } from "../../data/site";

export default function Instructions() {
  useEffect(() => {
    document.title = "Instructions - Aldebaran";
  }, []);

  return (
    <div className="page">
      <div className="page__container">
        <header className="page__hero">
          <p className="page__eyebrow">Get started</p>
          <h1 className="page__title">Start earning {TOKEN} in minutes</h1>
          <p className="page__lead">
            Buy {TOKEN} once, hold it in your own wallet, and let the protocol
            auto-stake and auto-compound your rewards around the clock - no
            staking screen, no claim button, nothing to manage.
          </p>
        </header>

        <section className="page__section">
          <h2>How to begin</h2>
          <ol className="page__steps">
            <li className="page__step">
              <h3>Set up a TON wallet</h3>
              <p>
                Install a non-custodial TON wallet such as Tonkeeper or Tonhub,
                then create a new wallet and back up your recovery phrase
                offline. You stay in full control of your keys at every step.
              </p>
            </li>
            <li className="page__step">
              <h3>Fund it with TON</h3>
              <p>
                Add some TON to your wallet to cover your purchase and network
                fees. You can buy TON directly inside Tonkeeper with a card or
                transfer it in from an exchange like OKX or Bybit.
              </p>
            </li>
            <li className="page__step">
              <h3>Swap TON for {TOKEN}</h3>
              <p>
                Open a TON decentralized exchange such as STON.fi or DeDust,
                paste the official {TOKEN} contract address below, confirm the
                token matches, and swap your TON for {TOKEN}.
              </p>
            </li>
            <li className="page__step">
              <h3>Hold {TOKEN} and let it compound</h3>
              <p>
                Simply keep {TOKEN} in your wallet. Rewards are distributed and
                auto-compounded back into your balance every 30 minutes - there
                is no staking screen to visit and nothing to claim by hand.
              </p>
            </li>
            <li className="page__step">
              <h3>Track your growing balance</h3>
              <p>
                Watch your {TOKEN} balance grow over time straight inside your
                wallet, or look up your address on a TON explorer such as
                Tonviewer or Tonscan for a full transaction history.
              </p>
            </li>
          </ol>
        </section>

        <section className="page__section">
          <h2>Contract address</h2>
          <div className="page__prose">
            <p>
              Always verify you are interacting with the official {TOKEN} token
              before swapping. Copy this contract address into your DEX and
              confirm it matches exactly.
            </p>
          </div>
          <div className="page__card">
            <p className="break-all">{WALLET}</p>
          </div>
        </section>

        <section className="page__section">
          <h2>Need help?</h2>
          <div className="page__prose">
            <p>
              Want the full picture before you buy? The{" "}
              <Button to="/documents" variant="ghost">
                documents
              </Button>{" "}
              cover tokenomics and the compounding mechanism in detail, and the{" "}
              <Button to="/audit" variant="ghost">
                audit
              </Button>{" "}
              reports walk through the security review of the smart contract.
            </p>
          </div>
        </section>

        <section className="page__section">
          <h2>Ready to dive in?</h2>
          <div className="page__prose">
            <p>
              Read the docs to understand exactly how {TOKEN} works, then review
              the independent audit for peace of mind.
            </p>
          </div>
          <div className="page__cta">
            <Button to="/documents" variant="ghost" className="btn--lg">
              Read the docs
            </Button>
            <Button to="/audit" className="btn--lg">
              View the audit
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
}
